<template>
  <div>
    <section-collapseable
      title="Custom Details"
      collapseable
      hide-initial-when-expanded
      editable
      @edit="$refs.contactCustomFieldModal.open(contact)"
    >
      <app-key-value-item
        v-for="field in visibleCustomFields"
        :key="field.id"
        :label="field.label"
        :value="field.value"
        :is-date="field.type === ENUMS.CustomFieldTypeEnum.Date.value"
        :is-currency="field.type === ENUMS.CustomFieldTypeEnum.Currency.value"
      ></app-key-value-item>

      <!-- Expanded Section -->
      <template v-slot:expanded>
        <app-key-value-item
          v-for="field in customFields"
          :key="field.id"
          :label="field.label"
          :value="field.value"
          :is-date="field.type === ENUMS.CustomFieldTypeEnum.Date.value"
          :is-currency="field.type === ENUMS.CustomFieldTypeEnum.Currency.value"
          :is-time="field.type === ENUMS.CustomFieldTypeEnum.Time.value"
        ></app-key-value-item>
      </template>
    </section-collapseable>

    <modal-container>
      <modal-crud-form
        ref="contactCustomFieldModal"
        title="Custom Details"
        form-component="contact-custom-fields-form"
        hide-delete-button
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import {ENUMS} from "../../../services/enums";
import dates from "../../../services/dates";

export default {
  name: "ContactCustomFields",
  computed: {
    contact() {
      return this.$store.state.activeContact ? this.$store.state.activeContact.contact : {
        custom_fields: [],
      };
    },
    allCustomFields() {
      return this.$store.getters.contactCustomFields;
    },
    contactCustomFields() {
      return this.contact.custom_fields;
    },
    customFields() {
      let customFields = this.allCustomFields.map(customField => {
        const contactField = this.contactCustomFields.find(field => field.id === customField.id);

        return {
          id: customField.id,
          order: customField.order,
          value: (contactField) ? this.formatValue(customField.type, contactField.value) : customField.default_value,
          type: customField.type,
          customFieldableType: customField.custom_fieldable_type,
          label: customField.label,
          options: customField.options,
          visible: customField.visible
        }
      });

      return customFields.sort((a, b) => a.order - b.order);
    },
    visibleCustomFields() {
      return this.customFields.filter(customField => customField.visible === true)
    }
  },
  methods: {
    formatValue(type, value) {
      if (ENUMS.CustomFieldTypeEnum.Time.value === type) {
        if (value) {
          return dates.formatAsTime(value);
        }
      }

      return value;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

</style>
